import type { FrapiTeaserItem } from '../../../../types/frapi-types.js';
import type { MapMarker, TeaserWithCoords } from './types.js';

import { console } from '../../../../../core/system/console/console.server.js';

export const filterWithCoordinates = (
  teasers: FrapiTeaserItem[],
): TeaserWithCoords[] =>
  teasers.filter((teaser): teaser is TeaserWithCoords => {
    const hasCoords = !!teaser.restaurantCoordinates;

    if (!hasCoords) {
      console.warn('Skipping teaser without coordinates:', {
        id: teaser.id,
        kicker: teaser.kicker,
      });
    }

    return hasCoords;
  });

export const toMapMarkers = (teasers: TeaserWithCoords[]): MapMarker[] =>
  teasers.map((teaser) => ({
    articleId: teaser.id,
    location: teaser.restaurantCoordinates,
    name: teaser.kicker ?? '',
  }));
